"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const api_1 = require("../../../api");
const constants_1 = require("../../../constants");
const react_bootstrap_1 = require("react-bootstrap");
const CompanyInfo_1 = require("./CompanyInfo");
const LoadingSpinner_1 = require("../../../shared/LoadingSpinner");
const DocumentTitle = require("react-document-title");
class Rate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            state: constants_1.ProgressState.None
        };
    }
    render() {
        let content = null;
        switch (this.state.state) {
            case constants_1.ProgressState.Loading:
                content = React.createElement(LoadingSpinner_1.default, { key: "Rate.Page.LoadingSpinner" });
                break;
            case constants_1.ProgressState.Success:
                content = this.renderRateContent();
                break;
            case constants_1.ProgressState.Failed:
                content = React.createElement("h1", null, "Wrong code");
                break;
        }
        return React.createElement("div", { className: "rate-page text-center" }, React.createElement(DocumentTitle, { title: "Rate" }), content);
    }
    renderRateContent() {
        const links = this.state.rateData.rateLinks.map((link, index) => {
            return React.createElement("a", { className: "rate-stars", key: index, href: link, style: { color: "#ffcc00", textDecoration: "none", fontSize: "30px" } }, "\u2605\u00A0");
        });
        return React.createElement("div", { className: "rate-landing-main text-center" }, React.createElement(CompanyInfo_1.default, { data: { name: this.state.rateData.businessName } }), React.createElement(react_bootstrap_1.Clearfix, null), React.createElement(react_bootstrap_1.Row, { className: "feedback-row text-center" }, React.createElement(react_bootstrap_1.Col, { className: "text-center", xs: 12 }, React.createElement("h2", null, " Please rate our service."))), React.createElement(react_bootstrap_1.Row, null, React.createElement(react_bootstrap_1.Col, { xs: 12 }, React.createElement("h3", null, "Poor\u00A0", links, "Excellent"))));
    }
    componentDidMount() {
        let code = this.props.params.code;
        api_1.doGet(api_1.API.v1.RATE_CODE(code)).then(response => {
            this.setState({
                rateData: response.data.rateData,
                state: constants_1.ProgressState.Success
            });
        }).catch(error => {
            this.setState({ state: constants_1.ProgressState.Failed });
        });
    }
}
exports.default = Rate;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/feedback/component/Rate.tsx
// module id = 1357
// module chunks = 1